import buildThreadContentItems from '@/lib/threads/buildThreadContentItems.js';

const removeThreadContentItem = (threadContent = [], threadId) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return buildThreadContentItems(threadContent);
  }

  return buildThreadContentItems(
    buildThreadContentItems(threadContent).filter((item) => {
      return String(item?.threadId || '').trim() !== normalizedThreadId;
    })
  );
};

export default removeThreadContentItem;
